<template>
	<section class="evaluation-sheet">
		<!-- 头部 -->
		<div class="header-es" v-if="data && Object.keys(data).length != 0">
			{{ data.year }}学年 - {{ data.grade_of_year }}{{ semester(data.semester) }}
		</div>

		<!-- 细节分 -->
		<div class="detail-metrics" v-if="data && Object.keys(data).length != 0">
			<el-table :data="metrics" :span-method="spanMethod" border style="margin-top: 20px;">
				<el-table-column prop="l1Name" label="一级指标" align="left" :width="120"></el-table-column>
				<el-table-column prop="l2Name" label="二级指标" align="left" :width="120"></el-table-column>
				<el-table-column label="三级指标" align="left" :width="320">
					<template v-slot:default="slot">
						<div class="l3-toolpit">
							<span>{{ slot.row.l3Name }}</span>
							<el-popover class="popover" placement="right-start" width="240" trigger="hover">
								<div class="comp-evaluation-sheet-l3-header">
									<span class="name"> {{ slot.row.l3Name }} ({{ slot.row.totalScore }}分)</span>
									<span class="description">{{ slot.row.description }}</span>
								</div>
								<div class="comp-evaluation-sheet-l3-content" v-if="slot.row.evaluation_indicator">
									<!-- 手动评级 -->
									<template
										v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.MANUAL_RATING.value"
									>
										<span>由老师直接评级</span>
									</template>
									<!-- 学生表现 -->
									<template
										v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value"
									>
										<div class="performance" v-if="performanceRules(slot.row.evaluation_indicator.extras.score_rule)">
											<span>扣分行为</span>
											<div class="rules">
												<template v-for="(rule, index) in slot.row.evaluation_indicator.extras.score_rule">
													<span
														:key="'performance' + index"
														v-if="rule.type === $api.student_evaluation.algorithm.REDUCE.value"
														>{{ rule.name }}</span
													>
												</template>
											</div>
										</div>
									</template>
									<!-- 申报 -->
									<template
										v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value"
									>
										<span
											v-if="
												slot.row.evaluation_indicator.declaration_process.process_type ===
												$api.evaluation_system.processType.ADD_SCORE.value
											"
											>提交材料进行申报，通过后累计加分进行评级</span
										>
										<span
											v-if="
												slot.row.evaluation_indicator.declaration_process.process_type ===
												$api.evaluation_system.processType.GET_GRADE.value
											"
											>提交材料进行申报，审批过程中由任课老师评级</span
										>
									</template>
									<!-- 练习单 -->
									<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.HOMEWORK.value">
										<div
											v-for="(rules, index) in slot.row.evaluation_indicator.extras.score_mapping"
											:key="'homework' + index"
											:class="{ reach: rules.grade === slot.row.scoreGrade }"
										>
											<span
												>评级{{ rules.grade }}：练习单获得{{ rules.homework_number }}个以上{{
													rules.homework_grade
												}}级达标</span
											>
										</div>
									</template>
									<!-- 正式考试 -->
									<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.EXAM.value">
										<span>根据正式考试最终成绩评级</span>
									</template>
									<!-- 日常测试 -->
									<template
										v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.DAILY_TEST.value"
									>
										<span>根据日常测试最终成绩评级</span>
									</template>
								</div>
								<svg class="icon" aria-hidden="true" slot="reference">
									<use xlink:href="#icon-iconfilli"></use>
								</svg>
							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="scoreGrade" label="评级" align="left" :width="120">
					<template v-slot:default="slot">
						<span
							v-if="data.state === $api.student_evaluation.evaluationState.PUBLIC.value"
							:class="{ second: !slot.row.scoreGrade }"
							>{{ slot.row.scoreGrade || '--' }}</span
						>
						<span v-else class="second">--</span>
					</template>
				</el-table-column>
				<el-table-column label="详情" align="left">
					<template v-slot:default="slot">
						<template v-if="slot.row.evaluation_indicator">
							<!-- 手动评级 -->
							<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.MANUAL_RATING.value">
								<span :class="{ second: !slot.row.comment }">{{ slot.row.comment || '暂无老师评级' }}</span>
							</template>
							<!-- 学生表现 -->
							<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value">
								<span :class="{ second: !performanceDetail(slot.row) }">{{
									performanceDetail(slot.row) || '暂无加减分记录'
								}}</span>
							</template>
							<!-- 申报 -->
							<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value">
								<div class="common-detail">
									<el-popover
										v-if="slot.row.source && slot.row.source.entities && slot.row.source.entities.length"
										placement="right-start"
										trigger="hover"
									>
										<div
											class="comp-evaluation-sheet-declaration"
											v-if="declarationStateRecord(slot.row.source.entities, $api.declaration.state.COMPLETED.value)"
										>
											<div class="title">
												<svg class="icon active" aria-hidden="true">
													<use xlink:href="#icon-iconfillsubmit"></use>
												</svg>
												<span class="text">已完成</span>
											</div>
											<div
												:class="{
													item: true,
													hover:
														$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
														de.author_uid === $store.state.user.userInfo.id
												}"
												v-for="(de, index) in slot.row.source.entities"
												:key="'declaration' + index"
												@click="toDeclarationDetail(de)"
											>
												<span v-if="de.entity.state === $api.declaration.state.COMPLETED.value">
													<span
														class="teacher-create"
														v-if="
															$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
															de.author_uid != $store.state.user.userInfo.id
														"
													>
														<span class="block">教师批量发起</span> 发起于{{ de.entity.created_at | formatDate }}
													</span>
													<span v-else> 发起于 {{ de.entity.created_at | formatDate }}</span>
													<svg
														class="icon"
														aria-hidden="true"
														v-if="
															$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
															de.author_uid === $store.state.user.userInfo.id
														"
													>
														<use xlink:href="#icon-iconoutlinearrowenter"></use>
													</svg>
												</span>
											</div>
										</div>
										<div
											class="comp-evaluation-sheet-declaration"
											v-if="declarationStateOnPassage(slot.row.source.entities)"
										>
											<div class="title">
												<svg class="icon" aria-hidden="true">
													<use xlink:href="#icon-iconfillsubmit"></use>
												</svg>
												<span class="text">在途中</span>
											</div>
											<div
												:class="{
													item: true,
													hover:
														$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
														de.author_uid === $store.state.user.userInfo.id
												}"
												v-for="(de, index) in slot.row.source.entities"
												:key="'declaration' + index"
												@click="toDeclarationDetail(de)"
											>
												<span
													v-if="
														de.entity.state != $api.declaration.state.COMPLETED.value &&
														de.entity.state != $api.declaration.state.REJECTED.value
													"
												>
													<span
														class="teacher-create"
														v-if="
															$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
															de.author_uid != $store.state.user.userInfo.id
														"
													>
														<span class="block">教师批量发起</span> 发起于{{ de.entity.created_at | formatDate }}
													</span>
													<span v-else> 发起于 {{ de.entity.created_at | formatDate }}</span>
													<svg
														class="icon"
														aria-hidden="true"
														v-if="
															$store.state.user.userInfo.type == $api.account.types.STUDENT.value &&
															de.author_uid === $store.state.user.userInfo.id
														"
													>
														<use xlink:href="#icon-iconoutlinearrowenter"></use>
													</svg>
												</span>
											</div>
										</div>
										<div class="record" slot="reference">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconfilli"></use>
											</svg>
											<span>申报记录</span>
										</div>
									</el-popover>

									<div v-else class="empty">暂无申报记录</div>
									<div
										class="link"
										@click="toDeclare(slot.row)"
										v-if="$store.state.user.userInfo.type == $api.account.types.STUDENT.value && !pastSemester"
									>
										<span>去申报</span>
										<svg class="icon" aria-hidden="true">
											<use xlink:href="#icon-iconoutlinearrowenter"></use>
										</svg>
									</div>
								</div>
							</template>
							<!-- 正式考试/日常测试 -->
							<template
								v-if="
									slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.EXAM.value ||
									slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.DAILY_TEST.value
								"
							>
								<div class="common-detail">
									<div v-if="slot.row.source && slot.row.source.entities.length">
										<span
											v-if="slot.row.scoreGrade && data.state === $api.student_evaluation.evaluationState.PUBLIC.value"
										>
											评级已公布
										</span>
										<span v-else class="empty">评测已结束，待老师公布评级</span>
									</div>
									<div v-else class="empty">根据评测成绩评级，评测暂未开始</div>
									<div
										class="link"
										v-if="slot.row.source && slot.row.source.entities.length"
										@click="toTestDetail(slot.row.source.entities)"
									>
										<span>查看评测</span>
										<svg class="icon" aria-hidden="true">
											<use xlink:href="#icon-iconoutlinearrowenter"></use>
										</svg>
									</div>
								</div>
							</template>
							<!-- 练习单 -->
							<template v-if="slot.row.evaluation_indicator.type === $api.evaluation_system.l3Type.HOMEWORK.value">
								<div class="common-detail">
									<div v-if="slot.row.scoreGrade">
										已达成 {{ slot.row.scoreGrade }} 级{{
											slot.row.scoreGrade != 'A' ? '，提高达标练习数量可提升评级' : ''
										}}
									</div>
									<div class="empty" v-else>暂无评级，练习次数或等级不足</div>
									<div
										class="link"
										v-if="
											slot.row.source &&
											slot.row.source.entities.length &&
											$store.state.user.userInfo.type == $api.account.types.STUDENT.value
										"
										@click="
											$router.push({
												name: 'studentTest',
												params: {
													sbid: data.subject_id
												}
											})
										"
									>
										<span>去练习</span>
										<svg class="icon" aria-hidden="true">
											<use xlink:href="#icon-iconoutlinearrowenter"></use>
										</svg>
									</div>
								</div>
							</template>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<!-- 总评-->
			<div
				class="sheet-summary"
				v-if="data && data.grade && data.state === $api.student_evaluation.evaluationState.PUBLIC.value"
			>
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-EvaluationSheetSeal"></use>
				</svg>
				<div class="sheet-grade">
					{{ this.data.grade }}
				</div>
			</div>

			<!-- 奖项 -->
			<div
				class="award"
				v-if="data.awards.length && data.state === $api.student_evaluation.evaluationState.PUBLIC.value"
			>
				<div class="title">
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-iconfilltrophy"></use>
					</svg>
					<span>获得的奖项</span>
				</div>
				<div class="list">
					<el-tooltip
						effect="dark"
						:content="awardRules(award)"
						placement="bottom"
						v-for="(award, index) in data.awards"
						:key="'student-award' + index"
					>
						<div class="item">
							<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-EvaluationSheetMedalDecorateLeft"></use>
							</svg>
							<span class="name">{{ award.name }}</span>
							<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-EvaluationSheetMedalDecorateRight"></use>
							</svg>
						</div>
					</el-tooltip>
				</div>
			</div>
		</div>

		<div v-if="!data || Object.keys(data).length == 0" class="empty-data">
			该学科无可用评估表
		</div>
	</section>
</template>

<script>
import moment from 'moment'

export default {
	props: {
		data: Object,
		pastSemester: Boolean
	},
	filters: {
		formatDate(date) {
			return moment(date).format('YYYY-MM-DD HH:mm')
		}
	},
	computed: {
		metrics() {
			if (
				!this.data ||
				!this.data.metrics ||
				!this.data.evaluation_template ||
				!this.data.evaluation_template.indicators
			)
				return []

			let res = []

			let metrics = this.data.evaluation_template.indicators
			for (let l1 of metrics) {
				let firstL1 = true

				for (let l2 of l1.children) {
					let firstL2 = true

					for (let l3 of l2.children) {
						let item = l3
						let toInsert = {
							l1Name: l1.label,
							l1Span: firstL1 ? l1.size : 0,
							l2Name: l2.label,
							l2Span: firstL2 ? l2.size : 0,
							l3Name: l3.name,
							description: item.description,
							totalScore: item.total_score,
							scoreGrade: null,
							comment: null,
							extras: null,
							updated_at: null
						}

						// 找指标对应的数据
						let metricVal = this.data.metrics.find(el => item.id === el.evaluation_indicator_id)
						toInsert.evaluation_indicator = item
						if (metricVal) {
							toInsert.scoreGrade = metricVal.grade || null
							toInsert.source = metricVal.source
							toInsert.comment = metricVal.comment
							toInsert.extras = metricVal.extras
							toInsert.updated_at = metricVal.updated_at
						}

						res.push(toInsert)

						firstL1 = false
						firstL2 = false
					}
				}
			}
			return res
		}
	},
	methods: {
		performanceDetail(row) {
			if (row.source) {
				if (row.source.entities && row.source.entities.length) {
					let reduce = 0
					let plus = 0
					for (let el of row.source.entities) {
						if (el.type === this.$api.student_evaluation.algorithm.REDUCE.value) reduce += el.count // 加分记录
						if (el.type === this.$api.student_evaluation.algorithm.PLUS.value) plus += el.count // 减分记录
					}
					return reduce + ' 次扣分记录，' + plus + ' 次加分记录'
				}
			}
			return null
		},
		declarationStateRecord(records, key) {
			return records.filter(el => el.entity.state === key).length
		},
		declarationStateOnPassage(records) {
			return records.filter(
				el =>
					el.entity.state != this.$api.declaration.state.COMPLETED.value &&
					el.entity.state != this.$api.declaration.state.REJECTED.value
			).length
		},
		performanceRules(rules) {
			// 只展示扣分行为
			return rules.filter(el => el.type === this.$api.student_evaluation.algorithm.REDUCE.value).length
		},
		awardRules(award) {
			//  奖项name 唯一，去评估表数据里找评奖规则
			let awardRule = this.data.evaluation_template.awards.find(el => el.name === award.name)
			// 从指标id 找到指标数据
			let indicator = this.metrics.find(
				el => el.evaluation_indicator && el.evaluation_indicator.id === awardRule.indicator
			)
			return indicator.l3Name + '指标等级为' + awardRule.grade + '时获得'
		},
		toDeclarationDetail(target) {
			if (
				this.$store.state.user.userInfo.type == this.$api.account.types.STUDENT.value &&
				target.author_uid === this.$store.state.user.userInfo.id
			) {
				this.$router.push({
					name: 'declarationView',
					params: {
						id: target.entity_id,
						sbid: this.data.subject_id
					}
				})
			}
		},
		toTestDetail(records) {
			// 找最新的评测记录
			const target = records.sort((a, b) => a.datetime < b.datetime)[0]
			if (this.$store.state.user.userInfo.type == this.$api.account.types.STUDENT.value) {
				this.$router.push({
					name: 'studentTestDetail',
					params: {
						asid: target.answersheet_id,
						tid: target.test_id,
						sbid: this.data.subject_id
					}
				})
			} else {
				this.$router.push({
					name: 'teacherViewAnswerSheet',
					params: {
						asid: target.answersheet_id,
						seid: target.test_serial,
						sbid: this.data.subject_id
					}
				})
			}
		},
		toDeclare(row) {
			this.$router.push({
				name:
					this.$store.state.user.userInfo.type == this.$api.account.types.STUDENT.value
						? 'declarationAdd'
						: 'declarationAddForTeacher',
				params: {
					sbid: row.evaluation_indicator.declaration_process.subject_id
				},
				query: {
					process_id: row.evaluation_indicator.declaration_process.id
				}
			})
		},
		semester(val) {
			switch (val) {
				case 1:
					return '上学期'
				case 2:
					return '下学期'
			}
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			switch (columnIndex) {
				case 0: {
					// L1
					return {
						rowspan: row.l1Span,
						colspan: 1
					}
				}
				case 1: {
					// L2
					return {
						rowspan: row.l2Span,
						colspan: 1
					}
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.evaluation-sheet {
	position: relative;
	margin: 20px;

	.empty-data {
		height: 200px;
		line-height: 200px;
	}

	.header-es {
		text-align: center;
		font-size: 36px;
		margin-top: 30px;
	}

	.sheet-summary {
		position: absolute;
		top: -20px;
		right: 0;
		height: 120px;
		width: 120px;
		transform: rotate(15deg);

		.icon {
			font-size: 120px;
		}

		.sheet-grade {
			font-size: 52px;
			text-align: center;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			color: #f13048;
			font-family: 'Bebas Neue';
		}
	}
	.detail-metrics {
		.el-table {
			.second {
				color: #ccc !important;
			}
			&.el-table--border {
				border-radius: 4px;
			}
			/deep/thead {
				th {
					border-top: none;
				}
			}
			/deep/tbody,
			thead {
				tr {
					td:nth-child(1),
					th:nth-child(1) {
						padding-left: 0;
					}
					td:last-child {
						padding-right: 0;
					}
				}
			}
			.l3-toolpit {
				.popover {
					height: 18px;
					margin-left: 2px;
					.icon {
						color: #ccc;
						font-size: 18px;
					}
				}
			}
		}
		.common-detail {
			display: flex;
			justify-content: space-between;
			line-height: 1em;
			.record {
				color: #21a74a;
				cursor: pointer;
				padding: 4px 8px;
				border: 1px solid #21a74a;
				border-radius: 4px;
				font-size: 12px;
			}
			.link {
				flex-shrink: 0;
				color: #21a74a;
				cursor: pointer;
				font-size: 12px;
			}
			.empty {
				color: #ccc;
			}
			div {
				display: flex;
				align-items: center;
				.icon {
					font-size: 16px;
				}
			}
		}
	}
	.award {
		margin: 24px 0 48px;
		.title {
			font-size: 18px;
			display: flex;
			align-items: center;
			color: #21a74a;
			.icon {
				font-size: 24px;
			}
		}
		.list {
			margin-top: 4px;
			display: flex;
			flex-wrap: wrap;
			.item {
				height: 40px;
				line-height: 40px;
				color: #21a74a;
				background: linear-gradient(90deg, #e8f6ec 0%, #ffffff 51%, #e8f6ec 100%, #e8f6ec 100%);
				border: 2px solid rgba(33, 167, 74, 0.2);
				border-radius: 24px;
				margin-right: 12px;
				margin-top: 8px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				min-width: 160px;
				.name {
					margin: 0 4px;
					font-weight: bold;
				}
				.icon {
					font-size: 28px;
				}
			}
		}
	}
}
.comp-evaluation-sheet-l3-header {
	span {
		display: block;
		&.name {
			color: #333;
		}
		&.description {
			font-size: 12px;
			color: #666;
			margin-top: 4px;
		}
	}
}
.comp-evaluation-sheet-l3-content {
	margin-top: 12px;
	color: #ccc;
	font-size: 12px;
	.performance {
		.rules {
			display: flex;
			flex-wrap: wrap;
			span {
				display: block;
				padding: 6px 12px;
				background: rgba(255, 31, 59, 0.1);
				border: 1px solid rgba(255, 31, 59, 0.1);
				border-radius: 4px;
				color: #f13048;
				margin-right: 4px;
				margin-top: 4px;
			}
		}
	}
	.reach {
		color: #21a74a;
	}
}
.comp-evaluation-sheet-declaration {
	&:first-of-type {
		margin-bottom: 12px;
	}
	.title {
		color: #666;
		display: flex;
		align-items: center;
		margin-bottom: 4px;
		.icon {
			margin-right: 2px;
		}
	}
	.item {
		font-size: 12px;
		color: #999;
		.teacher-create {
			color: #ccc;
			.block {
				height: 18px;
				line-height: 18px;
				padding: 0 4px;
				background: #fafafa;
				border: 1px solid #eeeeee;
				border-radius: 4px;
				margin-right: 4px;
			}
		}
		&.hover:hover {
			cursor: pointer;
			color: #21a74a;
			.icon {
				color: #21a74a;
			}
		}
	}
	.icon {
		color: #ccc;
		font-size: 16px;
	}
	.active {
		color: #21a74a;
	}
}
</style>
